import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import Alert from "../../utils/Alert";
import { isMarketUser } from "../../utils/AuthService";

import moment from "moment";
import _ from "lodash";

import {
  fetchItems,
  fetchItemsSuccess,
  fetchItemsFailure,
  fetchBrands,
  fetchBrandsSuccess,
  fetchBrandsFailure,
  fetchItemOffers,
  fetchItemOffersSuccess,
  fetchItemOffersFailure,
  fetchGrades,
  fetchGradesSuccess,
  fetchGradesFailure,
} from "../../store/inventories/actions";
import {
  createPurchaseOrder,
  createPurchaseOrderSuccess,
  createPurchaseOrderFailure,
  deletePurchaseOrder,
  deletePurchaseOrderSuccess,
  deletePurchaseOrderFailure,
  fetchPurchaseOrderDetail,
  fetchPurchaseOrderDetailSuccess,
  fetchPurchaseOrderDetailFailure,
  clearPurchaseOrderDetail,
} from "../../store/purchaseOrders/actions";

import {
  addItemToPurchaseOrder as addItemToPurchaseOrderStoreFunction,
  deleteItemFromPurchaseOrder,
  updateItemInPurchaseOrder as updateItemInPurchaseOrderStoreFunction,
  awaitPurchaseOrder,
  completePurchaseOrder,
} from "../../store/purchaseOrders/api";
import { getItems } from "../../store/inventories/api";

import Modal from "../../components/generics/Modal";

import Spinner from "../../components/generics/Spinner";
import PurchaseOrderByPriceDetail from "../../components/purchaseOrders/byPriceComponents/PurchaseOrderByPriceDetail";
import PurchaseOrderByPriceHeader from "../../components/purchaseOrders/byPriceComponents/PurchaseOrderHeader";
import PurchaseOrderInputBox from "../../components/purchaseOrders/byPriceComponents/PurchaseOrderInputBox";
import ItemPriceOptions from "./ItemPriceOptions";
import { withRouter } from "utils/WithRouter";

const styleFrame = {
  height: "0px",
  width: "0px",
  position: "absolute",
  display: "none",
};

const emptyItemState = {
  item: undefined,
  item_index: -1,
  item_info: null,
  quantity: "",
  presentation: undefined,
  brand: -1,
  has_grade: false,
  grade: -1,
  numberItems: "",
  price: "",
  selectedOffer: -1,
};

const PurchaseOrderDetailContainer = ({
  itemsList,
  gradesList,
  brandsList,
  offersList,
  fetchGrades,
  purchaseOrder,
  match,
  history,
  filterItems,
  fetchBrands,
  fetchItemOffers,
  fetchPurchaseOrderDetail,
  createPurchaseOrder,
  deletePurchaseOrder,
  clearPurchaseOrderDetailFunc,
}) => {
  const alertRef = useRef(null);
  const [waitModalVisible, setWaitModalVisible] = useState(false);
  const [optionsModalVisible, setOptionsModalVisible] = useState(false);
  const [isLoadingItems, setIsLoadingItems] = useState(false);
  const [itemsListState, setItemsListState] = useState([]);
  const [editingItem, setEditingItem] = useState(false);
  const [currentPo, setCurrentPo] = useState(null);
  const [errors, setErrors] = useState([]);
  const [deliveryDate, setDeliveryDate] = useState({});
  const [ordersReady, setOrdersReady] = useState({});
  const [deliveryDateError, setDeliveryDateError] = useState({});
  const [selectedItem, setSelectedItem] = useState(emptyItemState);

  // ========================================================================
  // code to avoid navigation
  // ========================================================================

  useEffect(() => {
    if (purchaseOrder.purchaseOrders && Object.keys(purchaseOrder.purchaseOrders).length === 0) {
      window.removeEventListener("beforeunload", alertUser);
      window.removeEventListener("unload", alertUser);
    } else {
      window.addEventListener("beforeunload", alertUser, { once: true });
      window.addEventListener("unload", alertUser, { once: true });
    }
    return () => {
      window.removeEventListener("beforeunload", alertUser);
      window.removeEventListener("unload", alertUser);
    };
  }, [purchaseOrder.purchaseOrders]);

  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
  };

  // ========================================================================
  // ========================================================================

  useEffect(() => {
    filterItems();
    fetchBrands();
    fetchGrades();
  }, []);

  useEffect(() => {
    setIsLoadingItems(false);
  }, [itemsListState]);

  useEffect(() => {
      clearPurchaseOrderDetailFunc(null, () => match.params.id !== "new" && fetchPurchaseOrderDetail(match.params.id));
  }, []);

  const spliceError = (element) => {
    let errorsConst = errors.slice();
    const index = errorsConst.indexOf(element);
    if (index !== -1) {
      errorsConst.splice(index, 1);
    }
    return errorsConst;
  };

  const searchItems = (input, callback) => {
    setIsLoadingItems(true);
    let options = [];
    getItems(input, null, null, null, null, true)
      .then((r) => {
        setItemsListState(r.data);
        // eslint-disable-next-line array-callback-return
        r.data.results.map((item) => {
          options.push({ value: item.id, label: item.name });
        });
        callback(options);
      })
      .catch((err) => {
        setIsLoadingItems(false);
      });
  };

  const handlePurchaseOrderSubmit = (waitAnyways = false) => {
    let hasErrors = false;
    let missingChecks = false;
    Object.keys(purchaseOrder.purchaseOrders).map((key) => {
      if (!deliveryDate[key]) {
        setDeliveryDateError({ ...deliveryDateError, [key]: "Plase select a delivery date" });
        hasErrors = true;
      }
      if (deliveryDateError[key]) {
        hasErrors = true;
      }
      if (!ordersReady[key]) {
        missingChecks = true;
      }
    });
    if (!hasErrors && (!missingChecks || waitAnyways)) {
      setWaitModalVisible(false);
      let checkedOrders = Object.keys(ordersReady).filter((key) => ordersReady[key]);
      checkedOrders.map((key, index) => {
        if (isMarketUser()) {
          completePurchaseOrder(key, { delivery_date: deliveryDate[key] });
        } else {
          awaitPurchaseOrder(key, { delivery_date: deliveryDate[key] });
        }
        alertRef.current.sendAlert("Your purchase order has been successfully sent", "success");
      });

      clearPurchaseOrderDetailFunc(history);
    } else if (!hasErrors && missingChecks && !waitAnyways) {
      setWaitModalVisible(true);
    }
  };

  const handleItemChange = (event) => {
    if (event === null || event.value === undefined) {
      setSelectedItem(emptyItemState);
    } else {
      const item_index = _.findIndex(itemsListState.results, function (o) {
        return o.id === event.value;
      });
      const item = itemsListState.results[item_index];
      let grade = selectedItem.grade;
      if (!item.has_grade) {
        grade = -1;
      }
      let newItem = {
        ...selectedItem,
        item: item,
        item_info: { value: item.id, label: item.name },
        item_index: item.id,
        presentation: item.master_packing_type,
        numberItems: item.master_packing_number ? item.master_packing_number : "",
        has_grade: item.has_grade,
        grade: grade,
      };
      setSelectedItem(newItem);
      fetchItemOffers(item.id, setSelectedItem, newItem);
      setErrors([]);
    }
  };

  const handleQuantityChange = (event) => {
    let errorsConst = errors.slice();
    const index_error = errorsConst.indexOf("quantity");
    //check if quantity is an integer and positive value
    if (!event.target.value || event.target.value <= 0) {
      if (index_error === -1) {
        errorsConst.push("quantity");
      }
    } else {
      if (index_error !== -1) {
        errorsConst = spliceError("quantity");
      }
    }
    setSelectedItem({ ...selectedItem, quantity: event.target.value });
    setErrors(errorsConst);
  };

  const handleBrandChange = (event) => {
    setSelectedItem({ ...selectedItem, brand: Number(event.target.value) });
    setErrors(spliceError("brand"));
  };

  const handleOfferChange = (event) => {
    let offer = offersList.offers.filter((offer) => offer.vendor_id === Number(event.target.value))[0];
    if (offer) {
      setSelectedItem({ ...selectedItem, selectedOffer: Number(event.target.value), price: offer.normalized_price, brand: offer.brand_id });
      setErrors(spliceError("price"));
    } else {
      let errorsConst = errors.slice();
      errorsConst.push("price");
      setErrors(errorsConst);
      setSelectedItem({ ...selectedItem, selectedOffer: -1, price: "" });
    }
  };

  const handleGradeChange = (event) => {
    setSelectedItem({ ...selectedItem, grade: Number(event.target.value) });
    setErrors(spliceError("grade"));
  };

  const handleNumberItemsChange = (event) => {
    let errorsConst = errors.slice();
    const index_error = errorsConst.indexOf("numberItems");
    //check if the number of items is an integer and positive value
    if (event.target.value && event.target.value <= 0) {
      if (index_error === -1) {
        errorsConst.push("numberItems");
      }
    } else {
      if (index_error !== -1) {
        errorsConst = spliceError("numberItems");
      }
    }
    setSelectedItem({ ...selectedItem, numberItems: event.target.value });
    setErrors(errorsConst);
  };

  const errorCheck = ({ item_index, brand, numberItems, quantity, price, has_grade, grade, selectedOffer }) => {
    let errorsConst = [];
    let index;
    if (
      item_index !== -1 &&
      brand !== -1 &&
      (!numberItems || numberItems > 0) &&
      quantity &&
      quantity > 0 &&
      price &&
      price > 0 &&
      selectedOffer !== -1
    ) {
      if (has_grade && grade === -1) {
        errorsConst = errors.slice();
        index = errorsConst.indexOf("grade");
        if (index === -1) {
          errorsConst.push("grade");
        }
        alertRef.current.sendAlert("All fields are required!");
        setErrors(errorsConst);
      }
    } else {
      errorsConst = errors.slice();
      if (item_index === -1) {
        index = errorsConst.indexOf("item");
        if (index === -1) {
          errorsConst.push("item");
        }
      }
      if (brand === -1) {
        index = errorsConst.indexOf("brand");
        if (index === -1) {
          errorsConst.push("brand");
        }
      }
      if (selectedOffer === -1) {
        index = errorsConst.indexOf("selectedOffer");
        if (index === -1) {
          errorsConst.push("selectedOffer");
        }
      }
      if (has_grade && grade === -1) {
        index = errorsConst.indexOf("grade");
        if (index === -1) {
          errorsConst.push("grade");
        }
      }
      if (numberItems && numberItems <= 0) {
        index = errorsConst.indexOf("numberItems");
        if (index === -1) {
          errorsConst.push("numberItems");
        }
      }
      if (!quantity || quantity <= 0) {
        index = errorsConst.indexOf("quantity");
        if (index === -1) {
          errorsConst.push("quantity");
        }
      }
      if (!price || price <= 0) {
        index = errorsConst.indexOf("price");
        if (index === -1) {
          errorsConst.push("price");
        }
      } else {
        alertRef.current.sendAlert("All fields are required!");
      }
      setErrors(errorsConst);
    }
    return errorsConst;
  };

  const addItemToPurchaseOrder = (poId) => {
    const { item_index, quantity, brand, has_grade, grade, numberItems, price } = selectedItem;
    addItemToPurchaseOrderStoreFunction(poId, {
      item: item_index,
      quantity: quantity,
      brand: brand,
      grade: has_grade ? grade : null,
      number_items: numberItems ? numberItems : 1,
      number_inventories: quantity,
      price: price,
    }).then(
      (response) => {
        alertRef.current.sendAlert(`${selectedItem.item.name} has been added to the purchase order`, "success");
        // Refresh Purchase Order
        fetchPurchaseOrderDetail(poId);
        setErrors([]);
      },
      () => {
        alertRef.current.sendAlert("The item could not be added.");
      }
    );
    setSelectedItem(emptyItemState);
  };

  const createPurchaseOrderCallback = (poId) => {
    addItemToPurchaseOrder(poId);
    setOrdersReady({ ...ordersReady, [poId]: false });
  };

  const addItem = () => {
    let poId = Object.keys(purchaseOrder.purchaseOrders).filter(
      (key) => purchaseOrder.purchaseOrders[key].vendor.id === selectedItem.selectedOffer
    )[0];
    const errorsConst = errorCheck(selectedItem);
    if (!errorsConst.length) {
      if (poId) {
        addItemToPurchaseOrder(poId);
      } else {
        var data = new FormData();
        data.append("vendor", selectedItem.selectedOffer);
        createPurchaseOrder(data, createPurchaseOrderCallback);
      }
    }
  };

  const handleDeleteItem = (itemId, poId) => {
    deleteItemFromPurchaseOrder(itemId).then(
      () => {
        // Refresh Purchase Order
        fetchPurchaseOrderDetail(poId);
        alertRef.current.sendAlert("Item was successfully removed from the purchase order", "success");
      },
      () => {
        alertRef.current.sendAlert("The item could not be deleted");
      }
    );
  };

  const handleDeleteTable = (poId) => {
    let ordersReadyCopy = ordersReady;
    delete ordersReadyCopy[poId];
    setOrdersReady(ordersReadyCopy);
    deletePurchaseOrder(poId, alertRef);
  };

  const clearSelectedItem = () => {
    setSelectedItem(emptyItemState);
    setErrors([]);
    setEditingItem(false);
  };

  const handleEditItem = (item, isChangingVendor) => {
    setCurrentPo(item.purchase_order);
    let vendorId = purchaseOrder.purchaseOrders[item.purchase_order].vendor.id;
    let price = offersList.offers.filter((offer) => offer.vendor_id === vendorId)[0].normalized_price;
    let itemIndex = item.id;
    if (isChangingVendor) {
      itemIndex = item.item;
    }
    setSelectedItem({
      item: item,
      item_index: itemIndex,
      item_info: { value: item.id, label: item.name },
      quantity: item.quantity,
      presentation: item.presentation,
      brand: item.brand.id,
      has_grade: item.grade !== null,
      grade: item.grade ? item.grade.id : -1,
      numberItems: item.number_items,
      price: price,
      selectedOffer: vendorId,
    });
    setErrors([]);
    setEditingItem(true);
  };

  const updateItemInPurchaseOrder = (item, poId) => {
    const { item: item_detail, item_index, quantity, brand, has_grade, grade, numberItems, price } = item;
    updateItemInPurchaseOrderStoreFunction(item_index, {
      purchase_order: poId,
      quantity: quantity,
      brand: brand,
      grade: has_grade ? grade : null,
      number_items: numberItems ? numberItems : 1,
      number_inventories: quantity,
      price: price,
    }).then(
      (response) => {
        alertRef.current.sendAlert(`${item_detail.name} has been updated!`, "success");
        // Refresh Purchase Order
        fetchPurchaseOrderDetail(poId);
        setErrors([]);
      },
      () => {
        alertRef.current.sendAlert("The item could not be updated");
      }
    );
  };

  const updateItem = () => {
    const errorsConst = errorCheck(selectedItem);
    if (!errorsConst.length) {
      updateItemInPurchaseOrder(selectedItem, currentPo);
      setSelectedItem(emptyItemState);
      setEditingItem(false);
    }
  };

  const handleDeliveryDate = (event, poId) => {
    let now = moment().format("YYYY-MM-DD");
    let deliveryDateConst = event.target.value ? moment(event.target.value).format("YYYY-MM-DD") : "";
    setDeliveryDate({ ...deliveryDate, [poId]: deliveryDateConst });
    if (now > deliveryDateConst) {
      setDeliveryDateError({ ...deliveryDateError, [poId]: "The delivery date cannot be in the past" });
    } else {
      const errorsCopy = deliveryDateError;
      delete errorsCopy[poId];
      setDeliveryDateError(errorsCopy);
    }
  };

  const handleCheck = (value, poId) => {
    setOrdersReady({ ...ordersReady, [poId]: value });
  };

  const handleShowOptions = (itemAndPo) => {
    handleEditItem(itemAndPo.item, true);
    setOptionsModalVisible(itemAndPo);
  };

  const handleChangeItem = (offer, item, po) => {
    addItem();
    handleDeleteItem(item.id, po.id);
    clearSelectedItem();
  };

  return (
    <div className="animated fadeIn">
      <Alert ref={alertRef} />
      <PurchaseOrderByPriceHeader
        handlePurchaseOrderSubmit={() => handlePurchaseOrderSubmit()}
        disabled={Object.keys(ordersReady).filter((key) => ordersReady[key] === true).length === 0}
        isMarketUser={isMarketUser()}
      />
      {purchaseOrder.status !== 2 && (
        <PurchaseOrderInputBox
          editingItem={editingItem}
          item={selectedItem.item_index}
          selectedItem={selectedItem.item_info}
          itemName={selectedItem.item && selectedItem.item.name}
          items={itemsList.items.results}
          onItemChange={handleItemChange}
          quantity={selectedItem.quantity}
          presentation={selectedItem.presentation}
          onQuantityChange={handleQuantityChange}
          brand={selectedItem.brand}
          brands={brandsList.brands.results}
          onBrandChange={handleBrandChange}
          selectedOffer={selectedItem.selectedOffer}
          itemOffers={offersList.offers}
          onOfferChange={handleOfferChange}
          hasGrade={selectedItem.has_grade}
          grade={selectedItem.grade}
          grades={gradesList.grades.results}
          onGradeChange={handleGradeChange}
          numberItems={selectedItem.numberItems}
          onNumberItemsChange={handleNumberItemsChange}
          price={selectedItem.price}
          addItem={addItem}
          updateItem={updateItem}
          cancelEditItem={clearSelectedItem}
          isLoadingItems={isLoadingItems}
          searchItems={searchItems}
          errors={errors}
        />
      )}
      {purchaseOrder.purchaseOrders &&
        Object.keys(purchaseOrder.purchaseOrders).map((key) => (
          <PurchaseOrderByPriceDetail
            purchaseOrder={purchaseOrder.purchaseOrders[key]}
            handleEditItem={handleEditItem}
            handleShowOptions={handleShowOptions}
            handleDeleteItem={handleDeleteItem}
            deliveryDate={deliveryDate[key]}
            deliveryDateError={deliveryDateError[key]}
            checked={ordersReady[key]}
            handleCheck={handleCheck}
            handleDeliveryDate={handleDeliveryDate}
            handleDeleteTable={handleDeleteTable}
          />
        ))}

      {purchaseOrder && purchaseOrder.loading ? <Spinner /> : null}
      <iframe id="ifmcontentstoprint" style={styleFrame}></iframe>
      <Modal
        closeModal={() => setWaitModalVisible(false)}
        isModalOpen={waitModalVisible}
        onConfirm={() => handlePurchaseOrderSubmit(true)}
        onCancel={() => setWaitModalVisible(false)}
        header={`${Object.keys(ordersReady).filter((key) => ordersReady[key] === true).length} out of ${
          Object.keys(purchaseOrder.purchaseOrders).length
        } orders selected`}
        content={`At least one order is not selected, if you continue that order will stay as in progress`}
        onConfirmButtonText={`Wait ${Object.keys(ordersReady).filter((key) => ordersReady[key] === true).length} orders`}
        onCancelButtonText="Cancel"
      />
      {optionsModalVisible && (
        <ItemPriceOptions
          itemAndPo={optionsModalVisible}
          closeModal={setOptionsModalVisible}
          handleChangeItem={handleChangeItem}
          onOfferChange={handleOfferChange}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    purchaseOrder: state.purchaseOrders.purchaseOrderDetail,
    itemsList: state.inventories.itemsList,
    brandsList: state.inventories.brandsList,
    gradesList: state.inventories.gradesList,
    offersList: state.inventories.offersList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPurchaseOrderDetail: (id) => {
      dispatch(fetchPurchaseOrderDetail(id)).payload.then(
        (response) => {
          dispatch(fetchPurchaseOrderDetailSuccess(response.data, true));
        },
        (error) => {
          dispatch(fetchPurchaseOrderDetailFailure(error));
        }
      );
    },
    filterItems: (query, station, page) => {
      dispatch(fetchItems(query, station, page)).payload.then(
        (response) => {
          dispatch(fetchItemsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchItemsFailure(error));
        }
      );
    },
    fetchBrands: () => {
      dispatch(fetchBrands(true)).payload.then(
        (response) => {
          dispatch(fetchBrandsSuccess(response.data));
        },
        (error) => {
          dispatch(fetchBrandsFailure(error));
        }
      );
    },
    fetchGrades: () => {
      dispatch(fetchGrades()).payload.then(
        (response) => {
          dispatch(fetchGradesSuccess(response.data));
        },
        (error) => {
          dispatch(fetchGradesFailure(error));
        }
      );
    },
    fetchItemOffers: (id, callback, selectedItem) => {
      dispatch(fetchItemOffers(id)).payload.then(
        (response) => {
          dispatch(fetchItemOffersSuccess(response.data));
          let selectedOffer = response.data.length ? response.data[0].vendor_id : -1;
          let price = response.data.length ? response.data[0].normalized_price : "";
          let brand = response.data.length ? response.data[0].brand_id : -1;
          callback({ ...selectedItem, selectedOffer, price, brand });
        },
        (error) => {
          dispatch(fetchItemOffersFailure(error));
        }
      );
    },
    createPurchaseOrder: (id, callback) => {
      dispatch(createPurchaseOrder(id)).payload.then(
        (response) => {
          dispatch(createPurchaseOrderSuccess(response.data, true));
          callback(response.data.id);
        },
        (error) => {
          dispatch(createPurchaseOrderFailure(error));
        }
      );
    },
    deletePurchaseOrder: (id, alertRef) => {
      dispatch(deletePurchaseOrder(id)).payload.then(
        (response) => {
          dispatch(deletePurchaseOrderSuccess(id));
          alertRef.current.sendAlert(`Purchase Order #${id} has been deleted successfully`, "success");
        },
        (error) => {
          dispatch(deletePurchaseOrderFailure(error));
          alertRef.current.sendAlert(`Purchase Order #${id} couldn't be deleted`);
        }
      );
    },
    clearPurchaseOrderDetailFunc: (history, callback) => {
      dispatch(clearPurchaseOrderDetail())
      if (history) history.push("/purchase_orders");
      if (callback) callback();
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseOrderDetailContainer));
